import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { DataTableModule } from 'angular2-datatable';
//import { DataFilterPipe } from './datafilterpipe';
import { CommonModule } from '@angular/common';
//import { TranslationsService} from '../../core/translations/translations.service';
//import { TranslationsModule} from '../../core/translations/translations.module';
//import {AppStorageService} from "../../app.storage.service";
import {FranchiseService} from '../../core/services/franchise.service';
import {BranchService} from '../../core/services/branch.service';
//import {OrderAppModel} from '../../models/order/order-app.model';
//import { environment } from '../../../environments/environment';
import { BranchesComponent } from './branches.component';
import { BranchesRoutingModule } from './branches-routing.module';
import { CoreModule} from '../../core/core.module';
import { TranslationsModule } from '../../core/translations/translations.module';
import { TranslationsService} from '../../core/translations/translations.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
// Alert Component
import { AlertModule } from 'ngx-bootstrap/alert';
import { LoaderModule } from '../loader/loader.module';

//import { ModalsComponent } from './modals.component';
import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

@NgModule({
  imports: [
    FormsModule,
    BranchesRoutingModule,
    CoreModule,
    LoaderModule,
    AppBreadcrumbModule,
    CommonModule,
    DataTableModule,
    TranslationsModule.forRoot(),
    AlertModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    CollapseModule.forRoot(),
    ModalModule.forRoot()
    
  ],
  declarations: [ BranchesComponent ],
  providers: [
    TranslationsService,
    BranchService,
    FranchiseService
   // AppStorageService
  ],
  exports: [
    BranchesComponent
  ],
})
export class BranchesModule { }
